import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import { ActualizarSolicitud } from '../../../redux/DuckUsuarioDeveloper/SolicitudesDevDuck';

const ModalEntregasParcialesComponent = (props) => {
    const dispatch = useDispatch()

    const informacionSolicitud = props?.informacionSolicitud
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 850,
        height: 470,
        bgcolor: '#E3EFF1',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black'
    };

    const [estatus, setEstatus] = React.useState('');

    const handleCloseModal = () => {
        //setOpenModalEntregasParciales(false)
        props.setOpenModal()
    }

    const cambioEstatus = async () => {
        if (informacionSolicitud?.idfc01_solicitudregistro) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc01_solicitudregistro, estatus: estatus, nameid: 'idfc01_solicitudregistro', tabla: 'fc_01_solicitudderegistro'
            }
        }))
        if (informacionSolicitud?.idfc05_solicitudusomarcaeimagen) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc05_solicitudusomarcaeimagen, estatus: estatus, nameid: 'idfc05_solicitudusomarcaeimagen', tabla: 'fc_05_solicitudusomarcaeimagen'
            }
        }))
        if (informacionSolicitud?.idfc06_registromaguey) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc06_registromaguey, estatus: estatus, nameid: 'idfc06_registromaguey', tabla: 'fc_06_registrodemaguey'
            }
        }))
        if (informacionSolicitud?.idfc08_renvacioncertificado) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc08_renvacioncertificado, estatus: estatus, nameid: 'idfc08_renvacioncertificado', tabla: 'fc_08_solicitudrenvacioncertificados'
            }
        }))
        if (informacionSolicitud?.idfc09_solicitudcertificado) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc09_solicitudcertificado, estatus: estatus, nameid: 'idfc09_solicitudcertificado', tabla: 'fc_09_solicitudemicioncertificadonomexportacionyentregahologram'
            }
        }))
        if (informacionSolicitud?.idfc30_notificaciontrasladodepr) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc30_notificaciontrasladodepr, estatus: estatus, nameid: 'idfc30_notificaciontrasladodepr', tabla: 'fc_30_notificaciontrasladodeproducto'
            }
        }))
        if (informacionSolicitud?.idfc31_solicitudseguimiento) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc31_solicitudseguimiento, estatus: estatus, nameid: 'idfc31_solicitudseguimiento', tabla: 'fc_31_solicitudseguimiento'
            }
        }))
        if (informacionSolicitud?.idfc33_solicitudenvasadonaciona) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc33_solicitudenvasadonaciona, estatus: estatus, nameid: 'idfc33_solicitudenvasadonaciona', tabla: 'fc_33_solicitudenvasadonacional'
            }
        }))
        if (informacionSolicitud?.idfc34_notificacionsuspencion) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc34_notificacionsuspencion, estatus: estatus, nameid: 'idfc34_notificacionsuspencion', tabla: 'fc_34_notificacionsuspencionyreactivacion'
            }
        }))
        if (informacionSolicitud?.idfc35_notificacionserviciosvar) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc35_notificacionserviciosvar, estatus: estatus, nameid: 'idfc35_notificacionserviciosvar', tabla: 'fc_35_notificaciondeserviciosvarios'
            }
        }))
        if (informacionSolicitud?.idfc36_solicitudactualizacion) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc36_solicitudactualizacion, estatus: estatus, nameid: 'idfc36_solicitudactualizacion', tabla: 'fc_36_solicituddeactualizacion'
            }
        }))
        if (informacionSolicitud?.idfc40_solicitudadquisicionholo) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc40_solicitudadquisicionholo, estatus: estatus, nameid: 'idfc40_solicitudadquisicionholo', tabla: 'fc_40_solicituddeadquisiciondehologramas'
            }
        }))
        if (informacionSolicitud?.idfc41_solicitudparabebidasconm) await dispatch(ActualizarSolicitud({
            data: {
                idSolicitud: informacionSolicitud?.idfc41_solicitudparabebidasconm, estatus: estatus, nameid: 'idfc41_solicitudparabebidasconm', tabla: 'fc_41_solicitudparabebidasconmezcal'
            }
        }))
        handleCloseModal()
    }
    const modalComponent = () => {
        return (
            <div className='row'>
                <Modal
                    open={props.openModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" className='text-danger' style={{ color: "white" }}>
                            <center ><h3 style={{ color: "purple", fontFamily: "Montserrat", fontWeight: "bold" }}> Entregas realizadas </h3></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" style={{ color: "black", textAlign: 'justify' }}>
                            <Box sx={{ height: 318, width: '100%', mt: 2 }}>
                                <label htmlFor="estatus">Seleccione el estatus:</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="estatus"
                                    value={estatus}
                                    onChange={e => setEstatus(e.target.valueAsNumber)}
                                />
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }} >
                            <div className='row'>
                                <button className={`btn btn-outline-success col-6`} onClick={() => cambioEstatus()/*handleCloseModal()*/}>Aceptar</button>
                                <button className={`btn btn-outline-danger col-6`} onClick={() => handleCloseModal()}>Cancelar</button>
                            </div>
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalEntregasParcialesComponent)
